// utils/momentPatch.js — Anamoria SPA
// v1.1 — MAX_PIECES exported for the in-place edit surface (July 22, 2026)
//   D-4.11: MomentDetailPage's edit state needs the piece cap; the contract
//   constant now lives with the contract helpers. (AddMemoryPage keeps its
//   own const untouched this pass — unification is a later cleanup item.)
// v1.0 — 4.1 edit-mode PATCH assembly (July 22, 2026)
//
// Pure functions implementing the piece-reconciliation rules R-1..R-4 of
// momentedit-4-1-spa-DRAFT-for-review-v0.2.md §2 against the deployed
// PATCH /moments/{id} contract (anamoria-memories v2.19, 4.0-B draft v0.2):
// keeps as { id } in position, adds as full specs, absent ids soft-deleted
// server-side (F-B2(a) trash round-trip intended).
//
// orderList is the single source of piece order:
//   { kind:'server', id, category } — existing piece, kept unless removed
//   { kind:'local',  localId }      — new piece; spec supplied at save time
//
// R-2: unknown categories are carried as keeps in position — dropping a
// token would soft-delete the piece. R-3: the first text piece maps to the
// write region; edited text replaces the piece IN PLACE (remove+add, A-2
// close); text written on a textless moment appends at the end.

// D5 / anamoria-memories v2.17+ contract: a moment holds at most 10 pieces.
export const MAX_PIECES = 10;

export function assemblePatchPieces(orderList, { text, baselineText, textPieceId, localSpecs }) {
  const trimmed = (text || '').trim();
  const baseTrimmed = (baselineText || '').trim();
  const pieces = [];
  let sawTextToken = false;
  for (const token of orderList) {
    if (token.kind === 'server') {
      if (textPieceId != null && token.id === textPieceId) {
        sawTextToken = true;
        if (trimmed === '') continue;                        // cleared → dropped
        if (trimmed === baseTrimmed) pieces.push({ id: token.id });
        else pieces.push({ type: 'text', note: trimmed });   // in-place replacement (A-2)
      } else {
        pieces.push({ id: token.id });                       // R-1 keep / R-2 carry
      }
    } else {
      const spec = localSpecs && localSpecs.get(token.localId);
      if (spec) pieces.push(spec);                           // R-4 add
    }
  }
  if (!sawTextToken && trimmed !== '') {
    pieces.push({ type: 'text', note: trimmed });            // new text, textless moment
  }
  return pieces;
}

// Combined piece count in edit mode (drives atCap and the A-6 last-piece rule).
export function countEditPieces(orderList, { text, textPieceId }) {
  const trimmed = (text || '').trim();
  let count = 0;
  let sawTextToken = false;
  for (const token of orderList) {
    if (token.kind === 'server' && textPieceId != null && token.id === textPieceId) {
      sawTextToken = true;
      if (trimmed !== '') count += 1;
    } else {
      count += 1;
    }
  }
  if (!sawTextToken && trimmed !== '') count += 1;
  return count;
}
